<template>
<div>
    <Modal
        :value="setAdminModel"
        :title="$t('loginPage.forget.title')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        >
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">

                 <FormItem  class="itemsss itemsss0 flexC" prop="email">
                    <div class="login-names">
                        <Icon type="ios-person-outline" size='24' />
                    </div>
                    <Input  v-model.trim="formData.email" :placeholder="$t('loginPage.forget.email')"></Input>
                </FormItem>

                <FormItem class="itemsss flexC" prop="vercode">
                    <div class="login-names">
                        <Icon type="ios-create-outline"  size='24'/>
                    </div>
                    <div style="display:flex;align-items: center">
                         <input type="text" v-model="formData.vercode"  @keyup.enter="loginSubmit"/>
                        <img @click="changeCaptcha" :src="captchaurl" class="login-imgs"/>
                    </div>
                </FormItem>
                    
                 <FormItem>
                    <Button :loading="disabled" type="primary" @click="subData('formData')">{{$t('confirm')}}</Button>
                </FormItem>
            </Form>
    </Modal>
</div>
</template>
<script>
/**
 *  忘记密码 弹框
 * @param dataRow  Object  点击的单条数据
 * @param setAdminModel boolean 对话框开关 true false  退款状态
 * @param fn function 回调函数
 */
import common from '@/common/common.js';
import {Message} from 'iview'
import moment from 'moment';
    export default {
        props:{
            setAdminModel: Boolean,
            fn:Function,
            dataRow: Object,
        },
        components: {

        },
        name: "Modelamdin",
        data () {
            return {
                disabled:false,//禁用确定按钮
                tabIndex:"1", //标签显示页
                captchaurl:'',
                formData: {//表单数据
                    email:"",
                    vercode:"",
                    checkCodeKey:'6dddc62b-929b-9246-d20c-b2a8dfd33d3b',
                    language:''
                }
            }
        },
        computed:{
            local(){
                return this.$store.state.local
            },
            ruleCustom(){
                return {//验证
                    email: [
                        { required: true, message: this.$t('required'), trigger: 'blur' },
                        { type: 'string', pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: this.$t('ruleCustom.email'), trigger:'blur'},
                    ],
                    vercode: [
                        { required: true, message: this.$t('ruleCustom.vercode'), trigger: 'blur' }
                    ]
                }
            }

        },
        watch:{  
            local(){
                this.changeRuleCustom()
            }       
        },
        created(){
             this.getCaptcha();
             this.changeRuleCustom()
        },
        methods: {
            changeRuleCustom(){
                if(this.local=='en-US'){
                    this.formData.language = 'en'
                }else if(this.local=='zh-CN'){
                    this.formData.language = 'zh'
                }
            },
            subData (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.axios.post(this.config.urlArray.forgotPassword,this.formData).then((result) => {
                           
                            if(result.data.code == 1){
                                 Message.success({
                                    content:result.data.data,
                                    duration:1.5,
                                    onClose: ()=>{
                                       this.cancel()
                                    }
                                })
                                
                                this.cancel()

                            }else{
                                common.ajaxMsg1(result.data,true)
                                this.changeCaptcha(); //刷新图形验证码
                                this.disabled = false
                            }
                            
                        }).catch((err) => {
                            this.disabled = false;
                            console.log(err)
                        });
                    }
                })
            },
            loginSubmit(event) { // enter快捷键
                event = event || window.event;
                if (event.keyCode === 13) {
                    this.subData('loginForm');
                }
            },
            changeCaptcha (){
                this.getCaptcha();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
            },
            getCaptcha () {
                let time = (new Date()).getTime()
                this.captchaurl = this.config.urlArray.getCaptcha+'?checkCodeKey='+this.formData.checkCodeKey+'&time='+time
            },
            cancel () {//对话框关闭
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false
                this.$emit('update:setAdminModel',false)
            }
           
        }
    }
</script>
<style   lang='less' scoped>
.ivu-form .ivu-form-item-label{
    width:120px ;
    text-align: center !important;
    text-indent: 1px;
  }
 /deep/ .ivu-form-item-content{
    margin-left: 0px !important;
    display: flex;
    // &:nth-of-type(1){
    //     width: calc(100% - 20px);
    // }
  }
  .itemsss0{
      /deep/ .ivu-form-item-content{
  
        width: calc(100% - 20px);
    }
  }
  /deep/ .ivu-input{
      border: 1px solid #fff;
      margin-left: 20px;
      outline: none;
      width: 100%;
      height: 38px;
  }
  /deep/ .ivu-btn-primary{
      margin: 0 auto
  }
  .ivu-modal{
      top:50%;
      transform: translateY(-50%);
  }
  .itemsss{
    width:86%;
    margin: 20px auto;
    display:flex;
    border:1px solid #DDDDDD;
    flex-wrap:nowrap;
    height: 40px;
    line-height: 40px;
    align-items: center;
    input{
        border: none;
        // width: 100%;
        outline: none;
    }
}
.login-names {
    width: 110px;
    padding-left: 10px;
    // height: 32px;
    line-height: 38px;
}
.login-imgs {
    margin-left: 17px;
    height: 38px;
}
</style>
